import React from 'react';
import { View, ScrollView, useWindowDimensions, Platform } from 'react-native';
import StatusBar from '../statusBar';
import getPlatformType from '../../helpers/helpers';
import DrawerMenu from '../../screens/drawerMenu/DrawerMenu';
import { Container } from './Drawer.style';
import StatusBarMobile from '../statusBarMobile';
import { useNavigation } from '@react-navigation/native';
import { useSelector } from 'react-redux';
import StatusBarTab from '../statusTabBar/StatusBarTab';
import FooterLanding from '../footerComponentLanding/customFooter';
import BottomTabBar from '../bottomTabBar/BottomTabBar';
import { COLORS, LAYOUT } from '../../constants/theme';

const drawerHoc = ({ Component, title, showBackButton, navigation, backNavigation, customWidth, noScroll }) => {
  const WrapperComponent = (props) => {
    const navigation = useNavigation();
    const userToken = useSelector((state) => state?.AppReducer?.token);
    const { width } = useWindowDimensions();

    const layoutType = width <= 1024 ? 'phone' : 'web';

    // ─── WEB layout ──────────────────────────────────────────────────────
    if (layoutType === 'web') {
      return (
        <View
          style={{
            flex: 1,
            height: Platform.OS === 'web' ? '100vh' : '100%',
            maxHeight: Platform.OS === 'web' ? '100vh' : '100%',
            overflow: 'hidden',
            flexDirection: 'row',
            backgroundColor: COLORS.appBg,
          }}
        >
          {/* Sidebar */}
          <View style={{ width: LAYOUT.sidebarWidth, flexShrink: 0, backgroundColor: COLORS.sidebarBg }}>
            <DrawerMenu />
          </View>

          {/* Main content area */}
          <View style={{ flex: 1, minWidth: 0, overflow: 'hidden', flexDirection: 'column' }}>
            {/* Top header bar */}
            <StatusBar
              backNavigation={backNavigation}
              title={title}
              backbutton={showBackButton}
              navigation={navigation}
            />

            {noScroll ? (
              <View style={{ flex: 1, minHeight: 0, position: 'relative' }}>
                <Component {...props} />
              </View>
            ) : (
              <ScrollView
                style={{ flex: 1 }}
                contentContainerStyle={{ flexGrow: 1 }}
                showsVerticalScrollIndicator={true}
              >
                <Container style={{ marginBottom: 0, paddingTop: 0 }} customWidth={customWidth}>
                  <Component {...props} />
                </Container>
              </ScrollView>
            )}

            {!userToken && <FooterLanding navigation={navigation} />}
          </View>
        </View>
      );
    }

    // ─── TABLET layout ────────────────────────────────────────────────────
    if (layoutType === 'tab') {
      return (
        <View
          style={{
            flex: 1,
            height: Platform.OS === 'web' ? '100vh' : '100%',
            maxHeight: Platform.OS === 'web' ? '100vh' : '100%',
            overflow: 'hidden',
            flexDirection: 'row',
            backgroundColor: COLORS.appBg,
          }}
        >
          {/* Icon-only sidebar */}
          <View style={{ width: LAYOUT.sidebarWidthTab, flexShrink: 0, backgroundColor: COLORS.sidebarBg }}>
            <DrawerMenu />
          </View>

          {/* Main content */}
          <View style={{ flex: 1, minWidth: 0, overflow: 'hidden', flexDirection: 'column' }}>
            <StatusBarTab
              backNavigation={backNavigation}
              title={title}
              backbutton={showBackButton}
            />

            {noScroll ? (
              <View style={{ flex: 1, minHeight: 0, position: 'relative' }}>
                <Component {...props} />
              </View>
            ) : (
              <ScrollView
                style={{ flex: 1 }}
                contentContainerStyle={{ flexGrow: 1 }}
                showsVerticalScrollIndicator={true}
              >
                <Container
                  style={{ marginBottom: 0, paddingTop: 50 }}
                  customWidth={customWidth}
                >
                  <Component {...props} />
                </Container>
              </ScrollView>
            )}

            {!userToken && <FooterLanding navigation={navigation} />}
          </View>
        </View>
      );
    }

    // ─── MOBILE (phone) layout ────────────────────────────────────────────
    return (
      <View
        style={{
          flex: 1,
          height: Platform.OS === 'web' ? '100vh' : '100%',
          maxHeight: Platform.OS === 'web' ? '100vh' : '100%',
          overflow: 'hidden',
          backgroundColor: COLORS.appBg,
          position: 'relative',
        }}
      >
        {/* Mobile top header */}
        <StatusBarMobile
          backNavigation={backNavigation}
          backbutton={showBackButton}
        />

        {/* Scrollable content container */}
        <View style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
          {noScroll ? (
            <View style={{ flex: 1, minHeight: 0, position: 'relative', paddingBottom: LAYOUT.bottomTabHeight }}>
              <Component {...props} />
            </View>
          ) : (
            <ScrollView
              style={{ flex: 1 }}
              contentContainerStyle={{
                flexGrow: 1,
                paddingBottom: LAYOUT.bottomTabHeight + 20,
              }}
              showsVerticalScrollIndicator={true}
            >
              <Container
                style={{ marginBottom: 0, paddingTop: 0 }}
                customWidth={customWidth}
              >
                <Component {...props} />
              </Container>
            </ScrollView>
          )}

          {!userToken && <FooterLanding navigation={navigation} />}
        </View>

        {/* Bottom tab bar — integrated fixed at screen bottom */}
        <BottomTabBar />
      </View>
    );
  };

  WrapperComponent.router = Component?.router;
  WrapperComponent.navigationOptions = Component?.navigationOptions;
  return WrapperComponent;
};

export default drawerHoc;
